
const programs = [
  {
    title: 'AI Product Engineer',
    subtitle: '4–6 months · Beginner‑friendly',
    bullets: ['LLMs, prompt engineering, agents', 'Build 6 portfolio projects'],
    tag: '100% live + async',
  },
  {
    title: 'Data Science & MLOps',
    subtitle: '5–7 months · Intermediate',
    bullets: ['Feature stores, pipelines, deployment', 'Model monitoring & governance'],
    tag: 'Capstone + job prep',
  },
  {
    title: 'Cloud & DevOps with AI',
    subtitle: '3–5 months · Beginner‑friendly',
    bullets: ['IaC, CI/CD, observability', 'AI‑assisted automation'],
    tag: 'Hands‑on labs',
  },
];

export default function Programs() {
  return (
    <section id="programs" className="bg-slate-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="flex items-end justify-between">
          <h2 className="text-2xl md:text-3xl font-bold">Programs</h2>
          <a href="#" class  =""  ></a>   </div>

        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map(p => (
            <article key={p.title} className="program-card reveal">
              <div className="program-thumb">
                <div className="p-5">
                        <h3 className="font-semibold">{p.title}</h3>
                        <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{p.subtitle}</p>
                        <ul className="mt-3 text-sm text-slate-600 dark:text-slate-300 list-disc ml-4">
                        {p.bullets.map(b => <li key={b}>{b}</li>)}
                        </ul>
                        <div className="mt-4 flex items-center justify-between">
                            <span className="text-xs px-2 py-1 rounded bg-slate-100 dark:bg-slate-800">{p.tag}</span>
                            <a href="#" className="text-brand-700 dark:text-brand-100 font-medium textticle"></a>
                        </div>
                    </div>
                </div>
                </article>
          ))}
        </div>
      </div>
       </section>
  );
}
